import { atomWithLocalStorage } from "../../uilts/state";

export const cateIdSelectedAtom = atomWithLocalStorage<string | null>(
  "cateIdSelectedAtom",
  null
);
